import ThemeConfigProvider from 'common/src/config/theme/themeConfig';
import { createRoot } from 'react-dom/client';

import { render as footerRenderer, IFooterConfig } from '@umu/home-footer';
import { render as headerRenderer, IHeaderConfig } from '@umu/home-header';
import { initHeader } from '@umu/umu-common-header';

import { trackPaymentEvent } from '@umu/umu-api';
import { ACTION_TYPE, PAGE_TYPE } from '@umu/umu-api/src/services/payment/paymentEvent';
import 'businessCommon/src/styles/businessCommon.scss';
import 'common/src/styles/common.scss';
import { App } from './app';
import { IPlanPricingPageData } from './interface/pageData';
import './planPricing.scss';
import { getAppData } from './service/planPricingService';

import { langOptions } from 'common/const';
import { getMenuData } from 'plan/@planPricing/service/getMenuData';
import CommercializePage from 'src/common/page';

class PlanPricing extends CommercializePage<IPlanPricingPageData> {
    constructor() {
        super(getAppData());
        this.render();
        trackPaymentEvent({ page_type: PAGE_TYPE.COMMODITY_UPGRADE_PAGE, action_type: ACTION_TYPE.VIEW });
    }
    public getInitState() {
        const state = {
            pageData: {
                siteHost: getAppData('siteHost'),
                userInfo: getAppData('userInfo') || {},
            },
        };
        return state;
    }

    public async render() {
        const store = this.getInitState();
        const pageData = store.pageData;
        const userInfo = pageData.userInfo as any;
        const siteHost = getAppData('siteHost');
        const LANG = getAppData('Lang');
        const SYSTEM = getAppData('SYSTEM');
        if (userInfo.umu_id && +userInfo.umu_id > 0) {
            initHeader({
                userInfo,
                siteHost: getAppData('siteHost'),
                lang: LANG,
                system: SYSTEM,
            });
        } else {
            const config = {
                siteHost,
                platform: 'twww',
                system: SYSTEM.toLocaleUpperCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                headerData: (await getMenuData()).header,
                langOptions,
            };
            headerRenderer(config as IHeaderConfig, document.querySelector('#common-header') as HTMLElement);
        }

        footerRenderer(
            {
                siteHost,
                platform: 'twww',
                system: SYSTEM.toLowerCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                langOptions,
                footerData: (await getMenuData()).footer,
            } as IFooterConfig,
            document.querySelector('#common-footer') as HTMLElement,
        );

        createRoot(document.querySelector('.doc-wide')!).render(
            <ThemeConfigProvider>
                <div>
                    <App {...pageData}></App>
                </div>
            </ThemeConfigProvider>,
        );
    }
}
export default new PlanPricing();
